'use client';

import * as React from 'react';
import jsCookie from 'js-cookie';
import Link from 'next/link';
import { useTranslations } from 'next-intl';
import { CloudSlash } from '@phosphor-icons/react';
import { StateCard } from '@unity/cloud-ui';

import { getClientEnv } from '@/lib/constants/environment';
import { PageCenterGrid } from '@/components/page-center-grid';
import { ThemeContext } from '../theme';
import themeConstants from '../theme/theme-constants';

const { PREVIEW } = getClientEnv();

export const PreviewLinkError = () => {
  const t = useTranslations();
  const { zoom } = React.useContext(ThemeContext);

  React.useEffect(() => {
    jsCookie.remove(PREVIEW);
  }, []);

  return (
    <PageCenterGrid>
      <StateCard
        icon={CloudSlash}
        title={t('page:preview-link-error:title')}
        ButtonProps={{
          color: 'primary',
          component: Link,
          href: '/',
          label: t('page:preview-link-error:go-back'),
        }}
        sx={{
          zoom: themeConstants.zoom[zoom],
        }}
      />
    </PageCenterGrid>
  );
};
